<div class="participant-light-container flex-start g-space-sm">
  @for (participant of this.participants(); track participant.id) {
    <cam-badge [value]="this.getFullName(participant)"></cam-badge>
  }
</div>
